const logStore = {
    state: () => ({
        logProductTypes: [],
    }),
    getters: {
        getLogProductTypes: (state) => () => { return state.logProductTypes },
        existLogProductType: (state) => () => { return state.logProductTypes && state.logProductTypes.length>0 },
    },
    mutations: {
        setLogProductTypes: (state, datas) => state.logProductTypes = datas
    },
    actions: {
        setLogProductTypes: ({commit}, datas) => commit('setLogProductTypes', datas)
    }
}

export default logStore